import QuestionViewer from '@/components/questions/question-viewer/question-viewer';
import { portfolioAPI } from '@/providers/apis/portfolio/portfolio';
import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { contentAPI } from '@/providers/apis/content/content';
import { formatTime } from '@/utils/date';
import TaxonomyCard from '@/components/cards/taxonomy-card/taxonomy-card';
import { getGradeRange } from '@/utils/utils';

@Component({
    name: 'report-pullup',
    components: {
        'question-viewer': QuestionViewer,
        'taxonomy-tag': TaxonomyCard,
    },
})

export default class ReportPullup extends Vue {

    // -----------------------------------------------------------
    // Properties


    @Prop()
    private collectionData: any;

    @Prop()
    private activeMember: any;

    private resourceResults: any = null;

    private fetchData: any = [];

    private isActive: number = 0;

    // -----------------------------------------------------------
    // Hooks

    private created() {
        this.fetchContentSummary();
    }

    // --------------------------------------------------------------
    // Actions

    private onClosePullup() {
        this.$emit('onClosePullup');
    }

    // ----------------------------------------------------------
    // Methods

    private fetchContentSummary() {
        const activeMember = this.activeMember;
        const collection = this.collectionData;
        const sessions = collection.sessions ? collection.sessions : [];
        const sessionId = sessions[sessions.length - 1] ? sessions[sessions.length - 1].id : null;
        const params = {
            userId: activeMember.id,
            itemId: collection.id,
            sessionId,
        };
        portfolioAPI.fetchPortfolioDetails(params).then((data: any) => {
            params.sessionId = data.selectedSessionId;
            if (data.selectedSessionId) {
                this.fetchData = data.usageData;
                const fetchDataPos = this.fetchData.length === 0 ? 0 : this.fetchData.length - 1;
                const summaryParams = {
                    userId: activeMember.id,
                    itemId: collection.id,
                    sessionId: data.selectedSessionId,
                    contentSource: this.fetchData[0].contentSource,
                };
                const contentPromise = collection.format === 'collection'
                    ? contentAPI.fetchCollection(collection.id) : contentAPI.fetchAssessment(collection.id);
                axios.all([
                    portfolioAPI.fetchContentSummary(summaryParams, collection.format),
                    contentPromise,
                ]).then(axios.spread((summaryContent, content) => {
                    this.parseResourceResults(summaryContent, content);
                }));
            } else {
                this.resourceResults = null;
                this.onClosePullup();
            }
        });
    }

    private parseResourceResults(summaryContent: any, content: any) {
        let resourceResults = summaryContent.resourceResults || [];
        summaryContent.resoruce = content;
        resourceResults = resourceResults.map((item: any) => {
            const resourceContent = content.children.find((question: any) => question.id === item.resourceId);
            item.resource = resourceContent;
            return item;
        });
        resourceResults = resourceResults.filter((item: any) => item.resource);
        // resourceResults = resourceResults && resourceResults.length ? resourceResults : content.children;
        this.$set(summaryContent, 'resourceResults', resourceResults);
        this.resourceResults = summaryContent;
    }

    private formatTime(time: number) {
        return formatTime(time);
    }

    private getGradeRange(score: any) {
        return getGradeRange(score);
    }

    private onSelectAttempt(attemptParam: any, index: any) {
        this.isActive = index;
        const activeMember = this.activeMember;
        const collection = this.collectionData;
        const sessions = collection.sessions ? collection.sessions : [];
        const sessionId = sessions[sessions.length - 1] ? sessions[sessions.length - 1].id : null;
        const params = {
            userId: activeMember.id,
            itemId: collection.id,
            sessionId: attemptParam.sessionId,
            contentSource: attemptParam.contentSource,
        };
        const contentPromise = collection.format === 'collection'
            ? contentAPI.fetchCollection(collection.id) : contentAPI.fetchAssessment(collection.id);
        axios.all([
            portfolioAPI.fetchContentSummary(params, collection.format),
            contentPromise,
        ]).then(axios.spread((summaryContent, content) => {
            this.parseResourceResults(summaryContent, content);
        }));
    }
}
